import moment from 'moment';

export const renderTrialsMessage = (today, trialEndsAt) => {
  const momentTrialEndsAt = moment(trialEndsAt).toDate();
  const isFutureDate = moment(today).isAfter(momentTrialEndsAt);
  const threeDaysBeforeTrial = moment(momentTrialEndsAt).subtract(3, 'day');
  const isThreeDaysToTrialEnd = moment(today).isSameOrAfter(threeDaysBeforeTrial);
  const isNull = trialEndsAt === null;
  const isUndefined = typeof trialEndsAt === 'undefined';

  return !isNull && !isUndefined && !isFutureDate && isThreeDaysToTrialEnd;
};

export const handleIsSameOrBefore = (today, endDate) => moment(today).isSameOrBefore(moment(endDate), 'day') &&
    moment(today).isSameOrBefore(moment(endDate), 'month') &&
    moment(today).isSameOrBefore(moment(endDate), 'year');



// WEBPACK FOOTER //
// ./app/lib/date.js